export { default as Login } from "./Login";
export { default as ForgotPassword } from "./ForgotPassword";
export { default as ResetPassword } from "./ResetPassword";
export { default as Page404 } from "./Page404";

export { default as Dashboard } from "./Dashboard/Dashboard";
export { default as Franchise } from "./Dashboard/Franchise";

export { default as UserList } from "./Administration/User/UserList";
export { default as UserAdd } from "./Administration/User/UserAdd";
export { default as UserEdit } from "./Administration/User/UserEdit";
export { default as UserDetail } from "./Administration/User/UserDetail";

export { default as StoreList } from "./Administration/Store/StoreList";
export { default as StoreAdd } from "./Administration/Store/StoreAdd";
export { default as StoreEdit } from "./Administration/Store/StoreEdit";
export { default as StoreDetail } from "./Administration/Store/StoreDetail";

export { default as ProductList } from "./Administration/Product/ProductList";
export { default as ProductAdd } from "./Administration/Product/ProductAdd";
export { default as ProductEdit } from "./Administration/Product/ProductEdit";
export { default as ProductDetail } from "./Administration/Product/ProductDetail";
export { default as ProductOrderList } from "./Administration/Product/ProductOrderList";

export { default as CategoryList } from "./Administration/Category/CategoryList";
export { default as CategoryAdd } from "./Administration/Category/CategoryAdd";
export { default as CategoryEdit } from "./Administration/Category/CategoryEdit";

export { default as ServiceList } from "./Administration/Service/ServiceList";
export { default as ServiceAdd } from "./Administration/Service/ServiceAdd";
export { default as ServiceEdit } from "./Administration/Service/ServiceEdit";

export { default as ProviderList } from "./Administration/Provider/ProviderList";
export { default as ProviderAdd } from "./Administration/Provider/ProviderAdd";
export { default as ProviderEdit } from "./Administration/Provider/ProviderEdit";
export { default as ProviderDetail } from "./Administration/Provider/ProviderDetail";

export { default as CustomerList } from "./Administration/Customer/CustomerList";
export { default as CustomerDetail } from "./Administration/Customer/CustomerDetail";

export { default as EmployeeList } from "./Administration/Employee/EmployeeList";
export { default as EmployeeAdd } from "./Administration/Employee/EmployeeAdd";
export { default as EmployeeEdit } from "./Administration/Employee/EmployeeEdit";
export { default as EmployeeDetail } from "./Administration/Employee/EmployeeDetail";

export { default as DailyBalance } from "./Report/Cash/DailyBalance/DailyBalance";
export { default as DailyBalanceDetail } from "./Report/Cash/DailyBalanceDetail/DailyBalanceDetail";
export { default as EmployeesBalance } from "./Report/Cash/EmployeesBalance/EmployeesBalance";
export { default as DetailedReport } from "./Report/Cash/DetailedReport/DetailedReport";

export { default as CategoryBalance } from "./Report/Balance/CategoryBalance/CategoryBalance";
export { default as PaymentBalance } from "./Report/Balance/PaymentBalance/PaymentBalance";
export { default as ServiceBalance } from "./Report/Balance/ServiceBalance/ServiceBalance";
export { default as ProductBalance } from "./Report/Balance/ProductBalance/ProductBalance";
export { default as DaysBalance } from "./Report/Balance/DaysBalance/DaysBalance";
export { default as CustomersBalance } from "./Report/Balance/CustomersBalance/CustomersBalance";
export { default as ReceiptBalance } from "./Report/Balance/ReceiptBalance/ReceiptBalance";
export { default as OfferBalance } from "./Report/Balance/OfferBalance/OfferBalance";

export { default as ProductsIn } from "./Report/StockMovement/ProductsIn/ProductsIn";
export { default as InternalConsumption } from "./Report/StockMovement/InternalConsumption/InternalConsumption";
export { default as Regularizations } from "./Report/StockMovement/Regularizations/Regularizations";
export { default as ProductsDevolutions } from "./Report/StockMovement/ProductsDevolutions/ProductsDevolutions";
export { default as Inventory } from "./Report/StockMovement/Inventory/Inventory";

export { default as OfferAdd } from "./Administration/Offer/OfferAdd";
export { default as OfferDetail } from "./Administration/Offer/OfferDetail";
export { default as OfferEdit } from "./Administration/Offer/OfferEdit";
export { default as OfferList } from "./Administration/Offer/OfferList";

export { default as QuotationList } from "./Administration/Quotation/QuotationList";
export { default as QuotationDetail } from "./Administration/Quotation/QuotationDetail";
export { default as QuotationAdd } from "./Administration/Quotation/QuotationAdd";
export { default as QuotationEdit } from "./Administration/Quotation/QuotationEdit";

export { default as RemoteSells } from "./RemoteSells";

export { default as RewardList } from "./Administration/Reward/RewardList";

export { default as NewsletterList } from "./Administration/Newsletter/NewsletterList";
export { default as NewsletterAdd } from "./Administration/Newsletter/NewsletterAdd";
export { default as NewsletterEdit } from "./Administration/Newsletter/NewsletterEdit";
export { default as NewsletterDetail } from "./Administration/Newsletter/NewsletterDetail";

export { default as CustomerResetPassword } from "./CustomerResetPassword";

export { default as ContactUs } from "./ContactUs";



// WEBPACK FOOTER //
// ./src/scenes/index.js